











































import { Component, Vue, Prop, Watch } from 'vue-property-decorator';
import publishObjectPath from '@/util/configRegistry';
import { performanceServer } from '@/api/installServer';

@Component({
  components: {},
})
export default class RectifyInfoDialog extends Vue {
  private visible = false;
  private formData: any = {
    rectifyContent: '',
    rectifyPicture: '',
    rectifyTime: '',
    rectifyRemark: '',
    hazardId: '',
  };
  fileList: any = [];
  headers: any = {};
  actionUrl: any = ''; // 图片上传
  private serverUrlImg = publishObjectPath.imgPathWater;

  private showDialog(data: any) {
    this.fileList = [];
    this.actionUrl = publishObjectPath.serverUrl + '/api/sysManage/sysFile';
    this.headers.Authorization = localStorage.getItem('token');
    this.visible = true;
    this.formData.hazardId = data.id;
    this.formData.rectifyContent = data.rectifyContent;
    this.formData.rectifyTime = data.rectifyTime;
    this.formData.rectifyPicture = data.rectifyPicture;
    this.formData.rectifyRemark = data.rectifyRemark;
    if (data.rectifyPicture) {
      performanceServer.getSysFile(data.rectifyPicture).then((res: any) => {
        if (res.code === '200' && res.data && res.data.length) {
          this.fileList = res.data;
          this.fileList.forEach((item: any) => {
            item.url = publishObjectPath.imgPathWater + item.path;
          });
        }
      });
    }
  }

  private handleSuccess(response: any, file: any, fileList: any) {
    const arr: any = [];
    fileList.forEach((item: any) => {
      if (item.response && item.response.data) {
        arr.push(item.response.data[0].id);
      } else {
        arr.push(item.id);
      }
    });
    this.formData.rectifyPicture = arr.toString();
  }

  private handleRemove(file: any, fileList: any) {
    const arr: any = [];
    fileList.forEach((item: any) => {
      if (item.response && item.response.data) {
        arr.push(item.response.data[0].id);
      } else {
        arr.push(item.id);
      }
    });
    this.formData.rectifyPicture = arr.toString();
  }

  private submitForm() {
    performanceServer.rectifyInfoSupplement(this.formData).then((res: any) => {
      if (res.code === '200') {
        this.$emit('refreshDetail');
        this.hideDialog();
      } else {
        this.$message.warning(res.msg);
      }
    });
    // const formComponent: any = this.$refs.form;
    // formComponent.validate((valid: any) => {
    //   if (valid) {
    //   }
    // });
  }
  private hideDialog() {
    this.formData = {
      rectifyContent: '',
    };
    this.visible = false;
  }
}
